<template>
  <div class="form-group">
    <slot></slot>
    <slot name="help-text"
      class="form-text help-text"
      v-if="$slots['help-text']">
    </slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/form-group.scss';
</style>
